import React from "react";
import PropTypes from "prop-types";
import { reduxForm } from "redux-form";
import RadioInput from "./RadioInput";
import MonthInput from "./MonthInput";
import YearInput from "./YearInput";
import TextInput from "./TextInput";
import WizardFooter from "./WizardFooter";
export const fields = [
  "is_veteran",
  "is_entitled_to_compensation",
  "dischargeMonth",
  "dischargeYear",
  "service_branch",
];

const validate = (values, props) => {
  const errors = {};
  if (values.is_veteran) {
    if (values.is_veteran === "yes") {
      if (!values.is_entitled_to_compensation) {
        errors.is_entitled_to_compensation = props.allText.shared.required;
      }
      if (!values.dischargeMonth) {
        errors.dischargeMonth = props.allText.shared.required;
      }
      if (!values.dischargeYear) {
        errors.dischargeYear = props.allText.shared.required;
      }
      if (!values.service_branch) {
        errors.service_branch = props.allText.shared.required;
      }
    }
  } else {
    errors.is_veteran = props.allText.shared.required;
  }
  return errors;
};

export const WizardFormSection01 = props => {
  const {
    allText,
    fields: {
      is_veteran,
      is_entitled_to_compensation,
      dischargeMonth,
      dischargeYear,
      service_branch,
    },
    handleSubmit,
    previousPage,
  } = props;
  const text = { ...allText.shared, ...allText.section01 };
  const progress = 0;
  return (
    <form onSubmit={handleSubmit} className="form-horizontal">
      <div className="wizard-page-content">
        <div className="page-title-container">
          <span className="page-title underline">{text.title}</span>
          <span className="wizard-text question-text">{text.subtitle}</span>
        </div>
        <div className="single-answer-margin">
          <div className="primary-question">{text.primaryQuestion}</div>
          <RadioInput text={text} field={is_veteran} />
        </div>
        <div className="military-extra-questions">
          {is_veteran.value === "yes" && (
            <div className="row supplemental">
              <div className="col-12 col-sm-4">
                <div className="wizard-text">{text.question01}</div>
                <RadioInput text={text} field={is_entitled_to_compensation} />
              </div>

              <div className="col-12 col-sm-4 dob-container">
                <div className="wizard-text">{text.question02}</div>

                <div className="row dob-input-container">
                  <div className="col-6">
                    <MonthInput text={text} field={dischargeMonth} />
                  </div>

                  <div className="col-6">
                    <YearInput
                      text={text}
                      field={dischargeYear}
                      monthSelected={dischargeMonth}
                      shouldCheckMonth={false}
                    />
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-4">
                <div className="wizard-text small-question">
                  {text.question03}
                </div>
                <TextInput
                  text={text}
                  field={service_branch}
                  placeholder={text.question03Placeholder}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      <WizardFooter
        text={text}
        previousPage={previousPage}
        progress={progress}
      />
    </form>
  );
};

WizardFormSection01.propTypes = {
  allText: PropTypes.object.isRequired,
  fields: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,
};

export default reduxForm({
  form: "wizard",
  fields,
  destroyOnUnmount: false,
  validate,
})(WizardFormSection01);



// WEBPACK FOOTER //
// ./src/components/WizardFormSection01.js